import React, { FC, ReactElement } from 'react';
import { IBlock } from '../DemoZoneMain';
import { Link } from 'react-router-dom';
import routes from '../../../../config/routes';
import { useSelector } from 'react-redux';
import { getContentDataIntro } from '../../../../stores/reducers/userData';
import cns from 'classnames';
import './demozone-list.sass';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';

interface Props {
  zoneItem: IBlock
}

const DemoZoneListItem: FC<Props> = ({ zoneItem }): ReactElement => {
  const { backendURL } = useSelector(getContentDataIntro);
  const { activeLangState } = useSelector(internalizationState);

  return (
    <div className={cns('zonedata-item', zoneItem.type && zoneItem.type)} style={{backgroundImage: `linear-gradient(rgba(0,104,181,.1), rgba(0,0,0,.4)), url(${backendURL}/${zoneItem.image})`}}>
      <div className="zonedata-item__content">
        <div className="zonedata-item__header">
          <h3 className="zonedata-item__title">
            { localeFieldResolver(zoneItem, 'title', activeLangState) }
          </h3>
        </div>

        <p className="zonedata-item__description">
          { localeFieldResolver(zoneItem, 'description', activeLangState) }
        </p>
      </div>
      <Link className="btn btn-primary btn--mobile-min zonedata-item__btn" to={`${routes.DEMOZONE_INFO}?code=${encodeURI(zoneItem.relatedPage)}`}>
        { activeLangState === 'ru' ? 'Подробнее' : 'More details' }
      </Link>
    </div>
  )
}

export default DemoZoneListItem

